import { generateTestId } from "@client-shared";

export const setConnectServiceStepTestId = (identifier: string): string =>
  generateTestId("ConnectServiceStep", identifier);
